import React from "react";
import { Shield, Scale, FileCheck2 } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="mt-24 border-t border-slate-200 bg-slate-900 text-slate-300" data-testid="app-footer">
      <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
        <div className="grid gap-10 md:grid-cols-3">
          <div>
            <div className="font-display text-2xl font-semibold tracking-tight text-white">Brickstok</div>
            <div className="overline mt-2" style={{ color: "#94a3b8" }}>AJBN Connect · Institutional Portal</div>
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-slate-400">
              Fractional access to institutional-grade UK commercial real estate. Structured, regulated, and settled through
              AJBN Connect infrastructure.
            </p>
          </div>

          <div className="md:col-span-2 grid gap-6 sm:grid-cols-3" data-testid="footer-trust-signals">
            <div className="rounded-md border border-slate-800 p-5">
              <div className="flex items-center gap-2">
                <Scale className="h-4 w-4 brickstok-gold" />
                <div className="overline" style={{ color: "#94a3b8" }}>Legal Counsel</div>
              </div>
              <div className="mt-3 font-display text-lg text-white">Specialist UK CRE</div>
              <div className="mt-1 text-xs text-slate-400">Compliance & structural counsel</div>
            </div>
            <div className="rounded-md border border-slate-800 p-5">
              <div className="flex items-center gap-2">
                <FileCheck2 className="h-4 w-4 brickstok-gold" />
                <div className="overline" style={{ color: "#94a3b8" }}>Statutory Audit</div>
              </div>
              <div className="mt-3 font-display text-lg text-white">Independent Oversight</div>
              <div className="mt-1 text-xs text-slate-400">Institutional audit & reporting</div>
            </div>
            <div className="rounded-md border border-slate-800 p-5">
              <div className="flex items-center gap-2">
                <Shield className="h-4 w-4 brickstok-gold" />
                <div className="overline" style={{ color: "#94a3b8" }}>Custody</div>
              </div>
              <div className="mt-3 font-display text-lg text-white">Ring-fenced SPV</div>
              <div className="mt-1 text-xs text-slate-400">Segregated title, per-asset</div>
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col justify-between gap-3 border-t border-slate-800 pt-6 text-xs text-slate-500 sm:flex-row">
          <div>© {new Date().getFullYear()} Brickstok · AJBN Connect Ltd. All rights reserved.</div>
          <div className="max-w-2xl sm:text-right" data-testid="footer-compliance-line">
            Structured with <span className="text-slate-300">independent statutory audit oversight</span> and{" "}
            <span className="text-slate-300">specialist legal counsel</span> aligned with UK commercial real estate frameworks.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
